import "@hotwired/turbo-rails"

Turbo.config.forms.confirm = (message, element) => {
  const dialog = document.getElementById("turbo-confirm")
  const parsedDialogParams = JSON.parse(message)
  const title = parsedDialogParams.title || "Confirm this action?"
  const text = parsedDialogParams.text || "Are you sure you want to do this?"
  const confirmAction = parsedDialogParams.confirm_action || "Confirm"
  const cancelAction = parsedDialogParams.cancel_action || "Cancel"

  dialog.querySelector("#dialog-title").innerHTML = title
  dialog.querySelector("#dialog-body").innerHTML = text
  dialog.querySelector("button[value='confirm']").innerHTML = confirmAction
  dialog.querySelector("button[value='cancel']").innerHTML = cancelAction
  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener("close", (event) => {
      resolve(dialog.returnValue === "confirm")
    }, {once: true})
  })
}
